import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_marketing_campaigns",
  ref: "addMarketingCampaignsModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_marketing_campaigns_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_marketing_campaigns_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_marketing_campaigns_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-12 form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_27 = { class: "modal-footer flex-center" }
const _hoisted_28 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_29 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_30 = { class: "indicator-label" }
const _hoisted_31 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_32 = { class: "indicator-progress" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add") + _ctx.t("marketingCampaigns.marketingCampaigns")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("marketingCampaigns.campaignName")), 1),
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("marketingCampaigns.status")), 1),
                    _createVNode(_component_el_form_item, { prop: "status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.status,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.t('marketingCampaigns.plan'),
                              value: 10
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('marketingCampaigns.processing'),
                              value: 20
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('marketingCampaigns.completed'),
                              value: 30
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('marketingCampaigns.void'),
                              value: 40
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("marketingCampaigns.parentCampaign")), 1),
                    _createVNode(_component_el_form_item, { prop: "parent_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.parent_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.parent_id) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          loading: _ctx.campaignLoading,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                style: {"width":"100%"}
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("marketingCampaigns.campaignPurpose")), 1),
                    _createVNode(_component_el_form_item, { prop: "purpose" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.purpose,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.purpose) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignPurposeOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                style: {"width":"100%"}
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("marketingCampaigns.campaignType")), 1),
                    _createVNode(_component_el_form_item, { prop: "type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.type) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignTypeOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                style: {"width":"100%"}
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("marketingCampaigns.startDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "start_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.start_date,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.start_date) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.commonChangeDefaultDate($event, _ctx.formData, 'start_date')))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("marketingCampaigns.endDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "end_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.end_date,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.end_date) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.commonChangeDefaultDate($event, _ctx.formData, 'end_date')))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("marketingCampaigns.description")), 1),
                    _createVNode(_component_el_form_item, { prop: "description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.description,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.description) = $event)),
                          type: "textarea",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_33
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}